import { Badge } from '@/components/ui/badge';

/**
 * The member's tier, as shown in the ribbon.
 *
 * `platinumPlus` is real Platinum+ eligibility (see `platinum_plus.py::is_eligible` — a Platinum
 * member who has completed the gate folder), so the badge and the Platinum+ ribbon item always
 * agree. The drip-removal add-on used to append a "+" here, which read as "Platinum+" and was
 * mistaken for the graduate space; it is a purchase, not a status, so it is no longer shown.
 */
const TierBadge = ({ tier, platinumPlus = false, size = 'sm' }) => {
  const configs = {
    bronze: {
      label: 'Bronze',
      className: 'bg-amber-600 text-white hover:bg-amber-700'
    },
    silver: {
      label: 'Silver',
      className: 'bg-gray-400 text-white hover:bg-gray-500'
    },
    gold: {
      label: 'Gold',
      className: 'bg-yellow-500 text-white hover:bg-yellow-600'
    },
    platinum: {
      label: 'Platinum',
      className: 'bg-purple-600 text-white hover:bg-purple-700'
    },
    free_comp: {
      label: 'VIP',
      className: 'bg-gradient-to-r from-cyan-500 to-purple-500 text-white'
    }
  };

  const config = (platinumPlus && tier === 'platinum')
    ? { label: 'Platinum+', className: 'bg-gradient-to-r from-[#C9A84C] to-[#8E6F2E] text-white' }
    : (configs[tier] || configs.bronze);

  const sizeClasses = {
    xs: 'text-[10px] px-1.5 py-0.5',
    sm: 'text-xs px-2 py-0.5',
    md: 'text-sm px-2.5 py-1',
    lg: 'text-base px-3 py-1.5'
  };

  return (
    <Badge
      className={`${config.className} ${sizeClasses[size]} font-semibold`}
      data-testid="tier-badge"
    >
      {config.label}
    </Badge>
  );
};

export default TierBadge;
